module.exports = __webpack_public_path__ + "static/media/creatio.9d5021eb.png";